import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import { useNavigate } from "react-router-dom";
import "rsuite/dist/rsuite.css";

function SkuEditPopup({ show, onClose, rfqId, mainSku, prodsId }) {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        watch,
        setValue,
    } = useForm();

    const [isModalOpen, setIsModalOpen] = useState({
        show: false,
        message: "",
        btntext: "",
        title: "",
    });
    const navigate = useNavigate();

    const { data: editedSKU, postData: editSkuID } = usePostRequest(
        API_ENDPOINTS.UPDATE_SKU_ID
    );

    const onSuccessEdit = (res) => {
        toast.success(res?.message || "SKU changed successfully.")
        navigate(`/products-list`);
        // window.location.href = `/edit-order/${res.target_id}`;
    }

    const onErrorEdit = (err) => {
        toast.error(err?.message || "Some error occured while editing the SKU, please try again.")
    }

    const onSubmit = async (data) => {

        const response = await editSkuID({
            sku_display_name: data.order_id,
            old_sku_id: mainSku,
            old_sku_display_name: rfqId,
            product_id: prodsId,
        }, onSuccessEdit, onErrorEdit);
    };

    return (
        <>
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header
                    className="justify-content-center d-block text-center"
                    closeButton
                >
                    <Modal.Title className="tittle_deal">
                        <span className="text-green">Edit SKU</span>
                    </Modal.Title>
                    <p className="mb-0">
                        Please enter the new SKU below.
                    </p>
                </Modal.Header>

                <Form>
                    <Modal.Body>

                        <div className="mb-3 fw-bold">
                            Current SKU: <span className="text-primary">{rfqId}</span>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                New SKU
                            </Form.Label>
                            <InputGroup>
                                <Form.Control
                                    {...register("order_id")}
                                    placeholder="Enter Order ID"
                                    defaultValue={rfqId}
                                />
                            </InputGroup>
                        </Form.Group>

                    </Modal.Body>

                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="warning"
                            type="button"
                            onClick={handleSubmit(onSubmit)}
                        >
                            Submit
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default SkuEditPopup;
